import EventSourcePolyfill from 'eventsource-polyfill'

export default {
  data() {
    return {
      esInstance: null // SSE 实例
    }
  },
  methods: {
    /**
     * 建立 SSE 连接
     * @param {String} url - SSE 接口地址
     * @param {Object} options - 配置项（自定义头、重连等）
     */
    initSSE(url, options = {}) {
        console.log(url, options, 'initSSE')
      // 关闭已有连接
      this.closeSSE()

      // 配置参数（支持自定义请求头，polyfill 扩展能力）
      const token = this && this.$store && this.$store.state &&
        this.$store.state.login ? this.$store.state.login.token : ''
      const esOptions = {
        xhrHeaders: {
          'Accept': 'text/event-stream',
          'Cache-Control': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest',
          ...(options.headers || {}),
          ...(token ? { Authorization: token } : {})
        },
        retry: options.retry || 3000
      }

      // 创建 polyfill 版 EventSource 实例
      this.esInstance = new EventSourcePolyfill(url, esOptions)

      // 通用事件监听
      this.esInstance.onmessage = (e) => {
        if (e.data === '[DONE]') {
          this.closeSSE()
          return
        }
        let parsed
        try { parsed = JSON.parse(e.data) } catch (err) { parsed = e.data }
        this.$emit('sse-message', parsed)
      }

      // 错误处理
      this.esInstance.onerror = (err) => {
        console.error('SSE 错误：', err)
        this.$emit('sse-error', err)
        // 手动重连（可选）
        if (this.esInstance &&
          this.esInstance.readyState === this.esInstance.CLOSED) {
          setTimeout(() => this.initSSE(url, options), esOptions.retry)
        } else {
          this.closeSSE()
        }
      }
    },
    // 关闭 SSE 连接
    closeSSE() {
      if (this.esInstance) {
        this.esInstance.close()
        this.esInstance = null
      }
    }
  },
  // 组件销毁时自动关闭
  destroyed() {
    this.closeSSE()
  }
}
